import lazyLoading from "./lazyLoading";

export default {
  name: "offers",
  meta: {
    icon: "fa-shopping-bag",
    expanded: false,
    label: "Offres",
    permissions: "list offers"
  },

  children: [
    {
      name: "list-categories",
      path: "/admin/offers/categories",
      meta: {
        title: "Liste des catégories",
        label: "Catégories",
        permissions: "list offer categories"
      },
      component: lazyLoading("offers/CategoryList")
    },
    {
      name: "list-offers",
      path: "/admin/offers/list",
      meta: {
        title: "Liste des offres",
        label: "Offres",
        permissions: "list offers"
      },
      component: lazyLoading("offers/OffersList")
    },
    {
      name: "list-sessions",
      path: "/admin/sessions/list",
      meta: {
        title: "Liste des sessions",
        label: "Sessions",
        permissions: "list sessions"
      },
      component: lazyLoading("offers/SessionsList")
    },
    {
      name: "list-promo-codes",
      path: "/admin/promo/list",
      meta: {
        title: "Liste des Codes Bourse",
        label: "Code Bourses",
        permissions: "list promo codes"
      },
      component: lazyLoading("offers/PromoCodesList")
    },
    {
      name: "discount-settings",
      path: "/admin/offers/discounts",
      meta: {
        title: "Réductions Boarding",
        label: "Réductions Boarding"
        //isAdminStaff: true,
      },
      component: lazyLoading("offers/Discounts")
    },
    {
      name: "discount-highschool-settings",
      path: "/admin/offers/discounts-highschool",
      meta: {
        title: "Réductions Supérieur",
        label: "Réductions Supérieur"
        //isAdminStaff: true,
      },
      component: lazyLoading("offers/DiscountsHighschool")
    },
    {
      name: "discount-eschool-settings",
      path: "/admin/offers/discounts-eschool",
      meta: {
        title: "Réductions E-school",
        label: "Réductions E-school"
        //isAdminStaff: true,
      },
      component: lazyLoading("offers/DiscountsEschool")
    },

  ]
};
